module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-toolbar', {
    staticClass: "main-toolbar ql-project-sub-header"
  }, [_c('project-tools-palette', {
    attrs: {
      "bookmarkNavOpened": _vm.bookmarkNavOpened,
      "historyIndex": _vm.historyIndex,
      "history": _vm.history,
      "listView": _vm.listView,
      "currentPage": _vm.currentPage,
      "selectedElement": _vm.selectedElement,
      "selectedPageRenameIndices": _vm.selectedPageRenameIndices,
      "locked": _vm.locked,
      "pageHeight": _vm.pageHeight,
      "pageWidth": _vm.pageWidth,
      "pageFollow": _vm.pageFollow
    },
    on: {
      "updateHistory": _vm.updateHistory,
      "toggleBookmarkNav": _vm.toggleBookmarkNav,
      "thumbnailSelectionClick": _vm.thumbnailSelectionClick,
      "setSelectedElement": _vm.setSelectedElement,
      "pasteCueNote": _vm.pasteCueNote,
      "copyElement": _vm.copyElement,
      "setScale": _vm.setScale,
      "pageUp": _vm.pageUp,
      "pageDown": _vm.pageDown,
      "setPage": _vm.setPage,
      "setFollowUid": _vm.setFollowUid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bdff4e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/sub-header.vue
// module id = 1269
// module chunks = 21